import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "searchInputComponent",
  class: "position-relative justify-content-center"
}
const _hoisted_2 = { class: "position-relative addressSearch" }
const _hoisted_3 = ["id", "placeholder", "disabled"]
const _hoisted_4 = ["onClick", "data-item"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageComponent = _resolveComponent("MessageComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "searchSelectIcon" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref: "inputField",
        id: _ctx.id,
        type: "text",
        class: "form-control text-align-center",
        placeholder: _ctx.placeHolder,
        disabled: _ctx.isDisabledInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchedValue) = $event)),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSearchModal && _ctx.openSearchModal(...args)))
      }, null, 8, _hoisted_3), [
        [_vModelText, _ctx.searchedValue]
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["position-absolute d-flex flex-column selectOptionContainer", {'d-none': _ctx.displayNoneClass}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCities, (location) => {
          return (_openBlock(), _createElementBlock("div", {
            key: location.id,
            onClick: ($event: any) => (_ctx.select($event, location)),
            "data-item": location.address,
            class: "selectOptionContainer__item flex flex-row align-items-center"
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "selectOptionContainer__item__icon" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(location.address), 1)
          ], 8, _hoisted_4))
        }), 128))
      ], 2)
    ]),
    (!_ctx.message.state)
      ? (_openBlock(), _createBlock(_component_MessageComponent, {
          key: 0,
          "message-class": 'error-address-message',
          message: _ctx.message.message
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ]))
}